module.exports = __webpack_public_path__ + "img/logo-red.f8339a1d.png";